<template>
  <v-footer>
    <v-flex xs12 style="text-align: center;">
      <span>
        {{ new Date().getFullYear() }} —
        <strong>Nutris</strong>
      </span>
    </v-flex>
  </v-footer>
</template>

<script>
export default {
  name: "appFooter"
};
</script>

<style scoped>
footer {
  padding: 15px;
  opacity: 0.7;
}

footer span {
  color: rgb(0, 96, 100);
  font-weight: bolder;
  opacity: 1;
}
</style>
